/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function PlaceholderCard({ icon, title, hasBorder, outlined, onClick, softBoxColor, bgColor, padding }) {
  return (
    <Card
      raised
      sx={({ borders: { borderWidth, borderColor } }) => ({
        height: "70%",
        backgroundColor: bgColor || "#e9ecef",
        //margin: 'auto',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        border: hasBorder || outlined ? `${borderWidth[1]} solid ${borderColor}` : "none",
        cursor: "pointer"
      })}
      onClick={onClick}
    >
      <SoftBox
        display="flex"
        flexDirection="column"
        justifyContent="center"
        textAlign="center"
        height="100%"
        p={ padding || 3}
      >
        <SoftBox color={ softBoxColor || "secondary"} mb={0}>
          <Icon fontSize="default" sx={{ fontWeight: "bold" }}>
            {icon}
          </Icon>
        </SoftBox>
        <SoftTypography variant="h6" color="secondary">
          {title.text}
        </SoftTypography>
      </SoftBox>
    </Card>
  );
}

// Setting default values for the props of PlaceholderCard
PlaceholderCard.defaultProps = {
  icon: "add",
  hasBorder: false,
  outlined: false,
  onclick: () => {},
  softBoxColor: "secondary",
  bgColor: "#e9ecef", 
  padding: 3,
};

// Typechecking props for the PlaceholderCard
PlaceholderCard.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.shape({
    variant: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  hasBorder: PropTypes.bool,
  outlined: PropTypes.bool,
  onClick: PropTypes.func, 
  softBoxColor: PropTypes.string,
  bgColor: PropTypes.string,
  padding: PropTypes.number,
};

export default PlaceholderCard;
